import React, { Component } from 'react';
import './ChildListItem.scss';
import WishList from './WishList';

class ChildListItem extends Component {
  renderCheckMark(fulfilled) {
    if (fulfilled) {
      return <i className="fa fa-check wish-list-check-icon" />;
    }
    return null;
  }

  render() {
    let child = this.props.child;
    if (!child) return null;
    let wishes = child.wishes;
    return (
      <div className="wish-list-group">
        <WishList wishes={wishes} child={child} />
      </div>
    );
  }
}

export default ChildListItem;



// WEBPACK FOOTER //
// ./src/Containers/ChildList/ChildListItem.js